import { useMutation } from '@tanstack/react-query'
import { authApi } from 'shared/api/auth'

export interface EnableTwoFactorRequest {
  secret: string
  otp: string
}

interface EnableTwoFactorResponse {}

const enableTwoFactor = async (data: EnableTwoFactorRequest) => {
  const response = await authApi.post<EnableTwoFactorResponse>(
    '/2fa/enable',
    data
  )
  return response.data
}

export const useEnableTwoFactor = ({
  onSuccess,
  onError
}: {
  onSuccess?: () => void
  onError?: () => void
}) => {
  const mutation = useMutation({
    mutationFn: (data: EnableTwoFactorRequest) => enableTwoFactor(data),
    onSuccess: () => {
      onSuccess?.()
    },
    onError: () => {
      onError?.()
    }
  })

  return { mutation }
}
